// Fix defensivo para cleave.js@1.6.0 (afecta a todos los inputs Cleave de la app).
//
// El componente no inicializa `lastInputValue` cuando el valor inicial está vacío
// (solo se setea en keydown o al formatear un valor existente). Si el primer
// cambio llega sin teclado (pegar con el ratón, autofill, input programático),
// su onChange llama getPostDelimiter(undefined) y lanza
// "Cannot read properties of undefined (reading 'slice')", perdiendo el valor.
//
// create-react-class captura los métodos autobindeables en __reactAutoBindPairs
// al crear la clase, así que hay que envolver ahí (no solo en el prototipo).
import Cleave from 'cleave.js/react'

const wrapOnChange = (original) =>
	function (event) {
		if (this.lastInputValue === undefined || this.lastInputValue === null) {
			this.lastInputValue = ''
		}
		return original.call(this, event)
	}

const patchAutoBindPairs = (proto) => {
	const pairs = proto && proto.__reactAutoBindPairs
	if (!pairs || !Array.isArray(pairs)) return
	for (let i = 0; i < pairs.length; i += 2) {
		if (pairs[i] === 'onChange' && typeof pairs[i + 1] === 'function') {
			pairs[i + 1] = wrapOnChange(pairs[i + 1])
		}
	}
}

if (Cleave && Cleave.prototype && !Cleave.prototype.__erpLastInputFix) {
	patchAutoBindPairs(Cleave.prototype)

	// Cobertura extra por si alguna instancia usa el prototipo directamente.
	if (typeof Cleave.prototype.onChange === 'function') {
		Cleave.prototype.onChange = wrapOnChange(Cleave.prototype.onChange)
	}

	Cleave.prototype.__erpLastInputFix = true
}
